import apiClient from './api';

export interface NoticeType {
  name: string;
  displayName: string;
}

export interface NoticeItem {
  id: number;
  title: string;
  type?: string;
  date: string;
  content?: string;
}

export interface NoticeDetail {
  id: number;
  title: string;
  content: string;
  type: string;
  date: string;
}

export interface PageableInfo {
  pageNumber: number;
  pageSize: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface NoticeResponse {
  content: NoticeItem[];
  pageable: PageableInfo;
  last: boolean;
  totalPages: number;
  totalElements: number;
  first: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  empty: boolean;
}

export const noticeService = {
  getNotices: async (
    universityId: number,
    page: number = 0,
    size: number = 5,
    sort: string = 'createdAt,Desc',
    type?: string
  ): Promise<NoticeResponse> => {
    const response = await apiClient.get<NoticeResponse>(
      `/universities/${universityId}/notices`,
      {
        params: { page, size, sort, ...(type ? { type } : {}) },
      }
    );
    return response.data;
  },

  getNoticeTypes: async (): Promise<NoticeType[]> => {
    const response = await apiClient.get<NoticeType[]>('/notices/types');
    return response.data;
  },

  getAnnouncementList: async (page: number = 1, type?: string): Promise<any> => {
    const response = await apiClient.get('/announcement/list', {
      params: { page, type },
    });
    return response.data;
  },

  getAnnouncementDetail: async (id: number): Promise<NoticeItem> => {
    const response = await apiClient.get<NoticeItem>(`/announcement/${id}`);
    return response.data;
  },

  getNoticeDetail: async (id: number): Promise<NoticeDetail> => {
    const response = await apiClient.get<NoticeDetail>(`/notices/${id}`);
    return response.data;
  },
};
